import { TmdxAvatar } from '@ds';
import styles from '../../CaseCard.module.scss';
import { CardHospitalType } from '../../types';

type CardHospitalProps = {
  withLine?: boolean;
  isEmptyHospital: boolean;
} & CardHospitalType;

export const CardHospital = ({ image, name, code, state = 'ST', isEmptyHospital, withLine }: CardHospitalProps) => {
  const opacity = isEmptyHospital ? 'opacity-55' : '';

  return (
    <div className={`flex gap-2 items-center text-l-m ${opacity}`}>
      <div>
        <TmdxAvatar
          type="facility"
          size="md"
          radius="md"
          src={image}
          name={code || state}
          fallbackInitials={false}
          isDisabled={isEmptyHospital}
        />
        {withLine && <div className={styles.hospitalLine} />}
      </div>
      <div className="flex text-s-m leading-5">
        <div className="truncate max-w-40">{name}</div>
        <span>,</span>
      </div>
      <span className="text-s-m text-base-20 truncate">{state}</span>
    </div>
  );
};
